import { useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { PublicHeader, PublicFooter } from "@/components/shared";

export default function ShowCode() {
  const { code } = useParams();
  return (
    <div className="flex min-h-screen flex-col">
      <PublicHeader />
      <div className="mx-auto max-w-md flex-1 px-4 py-16 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-brand-green/15 text-brand-green">
          <CheckCircle2 className="h-9 w-9" />
        </div>
        <h1 className="text-2xl font-black tracking-tight">Show this at the counter</h1>
        <p className="mt-2 text-muted-foreground">Present this code to redeem your discount. The staff will confirm it in-app.</p>
        <div className="mt-8 rounded-[16px] border-2 border-dashed border-brand-green/40 bg-card p-8">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-muted-foreground">Redemption code</p>
          <p className="mt-3 select-all font-mono text-4xl font-black tracking-[0.25em] text-brand-green" data-testid="redemption-code">
            {code}
          </p>
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          Once redeemed, your referrer&apos;s reward moves into escrow. Want to earn too?{" "}
          <a href="/login" className="font-semibold text-brand-green underline" data-testid="become-referrer-link">Start referring</a>.
        </p>
      </div>
      <PublicFooter />
    </div>
  );
}
